import { Comment } from '@ant-design/compatible';
import { t } from '@hefe/i18n';
import { BasketballMessage } from '@hefe/models';
import { colors } from '@hefe/ui';
import { formatDateTime } from '@hefe/utils';
import { Button, List, Row, Space, Typography } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '../../../../store/store';
import UserAvatar from '../../../core/components/user/user-avatar/user-avatar/user-avatar.component';
import HtmlParser from '../../../core/utils/html-parser/HtmlParser';
import { MessagesAppComponentProps } from '../messages-app/messages-app.component';

interface MessagesListComponentProps extends MessagesAppComponentProps {
  onMessageClick: (message: BasketballMessage | null) => void;
  fetchMoreMessages: any;
  mode: 'admin' | 'team' | 'user';
}

export default function MessagesListComponent(
  props: MessagesListComponentProps
) {
  const dispatch = useAppDispatch();
  const [loadingMoreMessages, setLoadingMoreMessages] = useState(false);
  const [selectedMessageId, setSelectedMessageId] = useState(0);

  const fetchMoreMessages = () => {
    setLoadingMoreMessages(true);
    dispatch(props.fetchMoreMessages(props.messages.current_page + 1))
      .unwrap()
      .catch(() => null)
      .finally(() => setLoadingMoreMessages(false));
  };

  return (
    <List
      loading={props.loading}
      style={{ height: '75vh', overflow: 'auto' }}
      itemLayout="horizontal"
      dataSource={props.messages.data}
      renderItem={(message) => {
        const selected = message.id === selectedMessageId;
        return (
          <div
            onClick={() => {
              setSelectedMessageId(selected ? 0 : message.id);
              props.onMessageClick(selected ? null : message);
            }}
          >
            <Comment
              style={{
                padding: '0px 5px 0px 5px',
                cursor: 'pointer',
                backgroundColor: selected ? colors.lightgrey : 'white',
              }}
              avatar={<UserAvatar user={message.sender} />}
              author={`${message.sender.firstname} ${message.sender.lastname}`}
              datetime={formatDateTime(message.created_at || '')}
              key={message.id}
              content={
                <Space direction="vertical" size={0}>
                  <Typography.Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                    {message?.title}
                  </Typography.Text>
                  {props.mode === 'user' && (
                    <Typography.Text style={{ fontSize: 10 }}>
                      {t('recipients')}:{' '}
                      {message?.own_recipients
                        ?.map((r) => r.firstname)
                        .join(', ')}
                    </Typography.Text>
                  )}
                  <Typography.Text>
                    {HtmlParser(message.text, {
                      removeAllTags: true,
                      removeLineBreaks: true,
                      maxTextLength: 80,
                    })}
                  </Typography.Text>
                </Space>
              }
            />
          </div>
        );
      }}
      footer={
        props.messages.next_page_url && (
          <Row justify="center">
            <Button
              onClick={() => fetchMoreMessages()}
              loading={loadingMoreMessages}
            >
              {t('load_more.messages')}...
            </Button>
          </Row>
        )
      }
    />
  );
}
